<template>
  <div class="checkbox" :class="{ error: error }">
    <div class="d-flex">
      <div
        @click="updateValue"
        @keyup.enter="updateValue"
        class="icon"
        :tabindex="0"
      >
        <div
          class="checkmark"
          :class="{ checked: modelValue === 'true' }"
        ></div>
      </div>
      <div class="label" v-html="label" />
    </div>
  </div>
</template>
<script>
export default {
  name: "check-box",
  props: {
    modelValue: String,
    label: String,
    state: String,
  },
  computed: {
    error() {
      return this.state && this.state.startsWith("ERROR");
    },
    errorMsg() {
      return this.error && this.state.split("ERROR").pop();
    },
  },
  methods: {
    updateValue() {
      switch (this.modelValue) {
        case "true":
          this.$emit("update:modelValue", "false");
          break;
        case "false":
          this.$emit("update:modelValue", "true");
          break;
      }
    },
  },
};
</script>
